import {uniqueId} from 'lodash'
import placesOfRegistration from '@/constants/placesOfRegistartion'
import personalBanks from '@/constants/personalBanks'

const routeToCompany = {
  name: 'CompanyContact',
  params: {
    id: 'client.id',
    company: 'clientCompany.id'
  }
}

const routeToClient = {
  name: 'ContactCard',
  params: {
    id: 'client.id'
  }
}

const columns = [
  {
    type: 'checkbox',
    width: '30px'
  },
  {
    type: 'index',
    width: '37px'
  },
  {
    title: 'Company name',
    prop: 'clientCompany.name',
    capitalize: true,
    route: routeToCompany,
    info: 'licenseNo',
    tax: 'clientCompany.trn',
    file: 'uploadFile[0]',
    width: 'minmax(200px, 2fr)'
  },
  {
    title: '',
    prop: 'clientCompany.trn',
    type: 'tax',
    filter: 'hasProperty',
    filterBy: {
      prop: 'trn',
      title: 'TRN'
    },
    width: 'minmax(30px, 50px)'
  },
  {
    title: 'Nickname',
    prop: 'client.nickName',
    capitalize: true,
    route: routeToClient
  },
  {
    title: 'Formed in',
    prop: 'clientCompany.formedIn',
    type: 'id',
    findIn: placesOfRegistration,
    width: 'minmax(80px, 120px)',
    route: routeToCompany,
    filters: placesOfRegistration,
    filterId: 'formedIn'
  },
  {
    title: 'Formed on',
    type: 'date',
    prop: 'clientCompany.formedOn',
    width: 'minmax(70px, 0.6fr)',
    filters: true,
    filterType: 'date',
    route: routeToCompany,
    filterId: 'formedOn'
  },
  {
    title: 'Banks',
    prop: 'clientCompany.banks',
    label: 'bankName',
    type: 'array',
    route: routeToCompany,
    filters: personalBanks,
    findIn: personalBanks,
    filterId: 'banks',
    width: 'minmax(100px, 0.5fr)'
  },
  {
    title: 'License Exp Date',
    type: 'date',
    editable: true,
    prop: 'licenseDate',
    width: 'minmax(115px, 0.6fr)',
    route: routeToCompany
  },
  {
    title: 'Status',
    prop: 'expireStatus',
    type: 'status',
    route: routeToCompany,
    width: 'minmax(135px, 0.5fr)'
  },
  {
    title: 'Comment',
    type: 'comment',
    prop: 'comment'
  },
  {
    title: 'Extra',
    filters: true,
    filterType: 'many',
    filterId: 'extra',
    width: '60px'
  },
  {
    type: 'toolbar',
    status: 'expireStatus',
    comment: 'comment',
    width: '25px'
  }
]

const prefix = 'contacts_tracking_licenses_column_'
const trackingLicensesTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export {trackingLicensesTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsTrackingList/trackingLicensesTable.js